// src/api/captcha.ts
import api from '@/lib/axios';
import type {
  GetCaptchaRequest,
  GetCaptchaResponse,
  VerifyCaptchaRequest,
  VerifyCaptchaResponse,
} from '@/types/captcha';

export const getCaptcha = (
  data: GetCaptchaRequest
): Promise<GetCaptchaResponse> => {
  return api.post('/captcha/get', data);
};

export const verifyCaptcha = (
  data: VerifyCaptchaRequest
): Promise<VerifyCaptchaResponse> => {
  return api.post('/captcha/verify', data);
};